import { Badge } from '@/components/ui-kit/badge';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import type { DocumentStatus } from '../constants/mock-contract-documents';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
  label?: string;
  className?: string;
}

const statusStyles: Record<DocumentStatus, string> = {
  draft: 'border-slate-300 bg-slate-100 text-slate-700',
  generation_completed: 'border-sky-200 bg-sky-100 text-sky-800',
  generated: 'border-sky-200 bg-sky-100 text-sky-800',
  preparation_success: 'border-sky-200 bg-sky-100 text-sky-800',
  rollout_success: 'border-amber-200 bg-amber-100 text-amber-800',
  signatory_signed_success: 'border-emerald-200 bg-emerald-100 text-emerald-800',
  signatory_signed_failed: 'border-orange-200 bg-orange-100 text-orange-700',
  document_completed: 'border-green-200 bg-green-100 text-green-800',
  document_cancelled: 'border-red-200 bg-red-100 text-red-700',
  document_declined: 'border-orange-200 bg-orange-100 text-orange-700',
  preparation_failed: 'border-red-200 bg-red-100 text-red-700',
  rollout_failed: 'border-red-200 bg-red-100 text-red-700',
  archived: 'border-slate-300 bg-slate-100 text-slate-800',
};

const defaultLabelKeyMap: Record<DocumentStatus, string> = {
  draft: 'ORGCONTRACTS_STATUS_DRAFT',
  generation_completed: 'ORGCONTRACTS_STATUS_GENERATION_COMPLETED',
  generated: 'ORGCONTRACTS_STATUS_GENERATION_COMPLETED',
  preparation_success: 'ORGCONTRACTS_STATUS_PREPARATION_SUCCESS',
  rollout_success: 'ORGCONTRACTS_STATUS_ROLLOUT_SUCCESS',
  signatory_signed_success: 'ORGCONTRACTS_STATUS_SIGNATORY_SIGNED_SUCCESS',
  signatory_signed_failed: 'ORGCONTRACTS_STATUS_SIGNATORY_SIGNED_FAILED',
  document_completed: 'ORGCONTRACTS_STATUS_DOCUMENT_COMPLETED',
  document_cancelled: 'ORGCONTRACTS_STATUS_DOCUMENT_CANCELLED',
  document_declined: 'ORGCONTRACTS_STATUS_DOCUMENT_DECLINED',
  preparation_failed: 'ORGCONTRACTS_STATUS_PREPARATION_FAILED',
  rollout_failed: 'ORGCONTRACTS_STATUS_ROLLOUT_FAILED',
  archived: 'ORGCONTRACTS_STATUS_ARCHIVED',
};

const DocumentStatusBadge = ({ status, label, className }: DocumentStatusBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge
      className={cn(
        'rounded-md px-2 py-0.5 text-xs font-semibold',
        statusStyles[status],
        className
      )}
    >
      {label ?? t(defaultLabelKeyMap[status])}
    </Badge>
  );
};

export default DocumentStatusBadge;
